import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mwTitleCase' })
export class MwTitleCasePipe implements PipeTransform {
  transform(input: string): string {
    return input.length === 0 ? '' : input[0].toUpperCase() + input.slice(1);
  }
}
